export const PROJECTS = 'PROJECTS';

export const SEND_EMAIL = 'SEND_EMAIL';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js